/*
创建者 李伟(2018.2.04)
*/
<template>
  <div class="conInner">
    <section id="content_wrapper">
      <div class="data">
        <h2>申请退换货</h2>
      </div>
      <div class="tip">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg">
          <div>
            <h2>温馨提示</h2>
            <p>1、<router-link :to="{path:'/help',query:{articleid: 14}}">我怎么进行退换货？</router-link>
            </p>
            <p>2、这里会显示您更多的订单。</p>
            <p>3、您还可以查看申请列表、申请退换货等操作。</p>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <div class="tab">
        <ul>
          <li v-bind:class="{'selected':tab==1}"><a v-on:click="changeTab(1)"><span>申请退换货</span></a></li>
          <li v-bind:class="{'selected':tab==2}"><a v-on:click="changeTab(2)"><span>申请列表</span></a></li>
        </ul>
      </div>
      <div v-bind:class="{ white_box: tab==1,form_wrap: tab==1 }">
        <div class="box" style="background-color: #fff;">
          <div class="top"></div>
          <div class="" style="padding: 20px;border-left: 1px solid #DBDBDB;border-right: 1px solid #DBDBDB;"
            v-if="tab==1" id="ivu-form">
            <Form ref="returnData" :model="returnData" :rules="ruleValidate" :label-width="150" style="width:400px;">
              <FormItem label="类型" prop="type">
                <RadioGroup v-model="returnData.type">
                  <Radio label="1">退货</Radio>
                  <Radio label="2">换货</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="所属订单" prop="order_sn">
                <Input v-model="returnData.orderSn" style="width:250px;!important;"
                  placeholder="请填写订单号,一次只能输入一个订单号"></Input>
              </FormItem>
              <FormItem label="商品货号" prop="goodsns">
                <Input v-model="returnData.goodsns" style="width:250px;!important;" placeholder="请输入订单的商品货号"></Input>
              </FormItem>
              <FormItem label="申请理由" prop="reason">
                <Select v-model="returnData.reason" style="width:250px;!important;" placeholder="请选择申请理由"
                  :transfer="true">
                  <Option value="1">商品描述不符</Option>
                  <Option value="2">少件/漏发</Option>
                  <Option value="3">卖家发错货</Option>
                  <Option value="4">包装/商品破损</Option>
                  <Option value="5">假冒品牌</Option>
                  <Option value="6">未按约定时间发货</Option>
                  <Option value="7">未收到货</Option>
                  <Option value="8">发票问题</Option>
                  <Option value="9">不合适/不喜欢</Option>
                  <Option value="10">质量问题</Option>
                  <Option value="11">换货</Option>
                  <Option value="12">其他问题</Option>
                </Select>
              </FormItem>
              <FormItem label="申请描述" prop="desc">
                <Input v-model="returnData.desc" style="width:250px;!important;" type="textarea"
                  :autosize="{minRows: 2,maxRows: 5}" placeholder="请填写申请描述"></Input>
              </FormItem>
              <FormItem style="margin-bottom: 0!important">
                <Button type="primary" @click="handleSubmit('returnData')">申请提交</Button>
                <Button type="ghost" @click="handleReset('returnData')" style="margin-left: 8px">重置</Button>
              </FormItem>
            </Form>
          </div>
          <div class="body" v-if="tab==2">
            <div class="empty" v-if="!returnsOrderList.length">暂无信息</div>
            <table cellspacing="0" cellpadding="3" class="liststyle" style="width: 100%" v-if="returnsOrderList.length">
              <tbody>
                <tr>
                  <th class="date">申请时间</th>
                  <th>订单号</th>
                  <th>申请类型</th>
                  <th>申请理由</th>
                  <th>申请描述</th>
                  <th>状态</th>
                  <th>操作</th>
                </tr>
              </tbody>
              <tbody>
                <tr class="hovertr" v-for="row in returnsOrderList">
                  <td class="date">{{formatDate(row.createTime)}}</td>
                  <td class="orderId">{{row.orderNo}}</td>
                  <td>{{row.typeText}}</td>
                  <td>{{row.applyReason}}</td>
                  <td><span :title="row.applyDesc">{{row.applyDesc | limitToNum(10)}}</span></td>
                  <td class="status">
                    <span v-if="row.state==0">申请已提交</span>
                    <span v-if="row.state==1">已拒绝</span>
                    <span v-if="row.state==2">已通过审核</span>
                    <span v-if="row.state==3">退货已收货</span>
                    <span v-if="row.state==4">完成</span>
                  </td>
                  <td class="oper" width="100">
                    <a v-if="row.state==0" v-on:click="cancleSq(row.returnOrderId)" class="del_favorite link blue">取消申请</a>
                    <a v-on:click="toOrderDetail(row.orderNo)" class="del_favorite link blue">查看</a>
                    <a v-if="row.state==2" class="del_favorite link blue"
                      v-on:click="recordDetail(row.orderNo)">退回补录</a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="pager_border" v-if="returnsOrderList.length">
              <Page ref="pages" :total="dataTotal" show-total :page-size="pageSize" @on-change="changepage" size="small"
                show-elevator></Page>
            </div>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
    </section>
    <Modal v-model="recordModal" title="填写退回快递单号">
      <div class="mb-10 p-l50">
        <label>快递公司：</label>
        <Select v-model="logistics" style="width:300px">
          <Option v-for="item in logisticsList" :value="item.code" :key="item.code">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="mb-10 p-l50">
        <label>快递单号：</label>
        <Input v-model="logisticsSn" placeholder="请填写快递单号" style="width: 284px" />
      </div>
      <div slot="footer">
        <Button class="ivu-btn ivu-btn-primary ivu-btn-large" size="large" @click="asyncOK">提交</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { returnApply, getReturnsOrderList, cancelReturnApply } from 'api/user.js';
import { getLogisticsList, sentLogistics } from 'api/order.js';
import { limitToNum } from 'api/index.js';
import { formatDate } from 'utils/tool';

export default {
  data() {
    return {
      returnData: {
        orderSn: '',
        goodsns: '',
        reason: '',
        type: '1',
        desc: ''
      },
      ruleValidate: {
        type: [
          { required: true, message: '请选择申请理由', trigger: 'change' }
        ],
        orderSn: [
          { required: true, message: '请填写所属订单', trigger: 'blur' }
        ],
        goodsns: [
          { required: true, message: '请填写商品货号', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请选择申请理由', trigger: 'change' }
        ],
        desc: [
          { required: true, message: '请填写申请描述', trigger: 'blur' },
          { type: 'string', max: 200, message: '不能超过200字', trigger: 'blur' }
        ]
      },
      tab: 1,
      dataTotal: 0,
      pageSize: 10,
      tabOldVal: '',
      favoriteList: [],
      returnApply: { type: true },
      returnsOrderList: [],
      recordModal: false,
      logistics: '',
      logisticsSn: '',
      logisticsList: [],
      ordersn: ''
    }
  },
  created() {
    if (this.$route.query.tab == 1) {
      this.tab = 1;
      this.returnData = {
        orderSn: '',
        goodsns: '',
        reason: '',
        type: '1',
        desc: ''
      };
    } else if (this.$route.query.tab == 2 || !this.$route.query.tab) {
      this.tab = 2;
      this.getReturnsOrderList(1);
    }
  },
  watch: {
    '$route': function () {
      if (this.$route.path === '/member/returnList') {
        if (this.$route.query.tab == 1) {
          this.tab = 1;
          this.returnData = {
            orderSn: '',
            goodsns: '',
            reason: '',
            type: '1',
            desc: ''
          };
        } else if (this.$route.query.tab == 2) {
          this.tab = 2;
          this.getReturnsOrderList(1);
        } else {
          this.tab = 2;
          this.getReturnsOrderList(1);
        }
      }
    }
  },
  methods: {
    matchReason(type) {
      switch (type) {
        case '1':
          return '商品描述不符';
          break;
        case '2':
          return '少件/漏发';
          break;
        case '3':
          return '卖家发错货';
          break;
        case '4':
          return '包装/商品破损';
          break;
        case '5':
          return '假冒品牌';
          break;
        case '6':
          return '未按约定时间发货';
          break;
        case '7':
          return '未收到货';
          break;
        case '8':
          return '发票问题';
          break;
        case '9':
          return '不合适/不喜欢';
          break;
        case '10':
          return '质量问题';
          break;
        case '11':
          return '换货';
          break;
        case '12':
          return '其他问题';
          break;
        default:
      }
    },
    asyncOK() {
      if (!this.logistics) {
        this.$Message.error('请选择快递公司');
        return;
      }
      if (!this.logisticsSn) {
        this.$Message.error('请填写快递单号');
        return;
      }
      let _params = {
        'logisticsNo': this.logisticsSn,
        'logisticsCompany': this.logistics,
        'orderNo': this.ordersn
      }
      sentLogistics(_params).then((json) => {
        if (json.resCode == '1') {
          this.$Message.success(json.resDesc);
          this.recordModal = false;
        } else {
          this.$Message.error(json.resDesc);
        }
      });
    },
    recordDetail(id) {
      this.recordModal = true;
      this.ordersn = id;
      if (!this.logisticsList.length) {
        getLogisticsList().then((response) => {
          if (response.resCode == '1') {
            this.logisticsList = response.data;
          } else {
            this.$Message.error(response.resDesc);
          }
        });
      }
    },
    // 提交退换货
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let _params = {
            "applyDesc": this.returnData.desc,
            "applyReason": this.returnData.reason,
            "goodsSns": this.returnData.goodsns,
            "orderNo": this.returnData.orderSn,
            "returnType": this.returnData.type
          }
          returnApply(_params).then((response) => {
            if (response.resCode == '1') {
              this.$Modal.success({
                content: response.resDesc,
                onOk: () => {
                  this.$refs[name].resetFields();
                  this.$router.push({
                    path: '/member/returnList'
                  })
                }
              });
            } else if (response.resCode == '2') { //退货需补邮费
              this.$Modal.confirm({
                title: '温馨提示',
                content: '<p>商品退货后已不满足包邮条件，若想退货请支付邮费！</p>',
                okText: "补邮费",
                closable: true,
                onOk: () => {
                  //弹出支付邮费链接
                  window.open(response.resDesc);
                },
                cancelText: "取消",
                onCancel: () => {
                }
              });
            } else {
              this.$Modal.error({
                content: response.resDesc,
                onOk: () => {
                  this.$refs[name].resetFields();
                  this.$router.push({
                    path: '/member/returnList'
                  })
                }
              });
            }
          });
        }
      })
    },
    // 重置表单数据
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    // tab 切换
    toggle: function (n) {
      if (n == 1 && !this.returnApply.type) { this.returnApply.type = true; }
      if (n == 2 && this.returnApply.type) { this.returnApply.type = false; }
    },
    changeTab: function (n) {
      this.tab = n
      if (this.tabOldVal != n) this.$router.push({ query: { tab: this.tab } });
      this.tabOldVal = n;
    },
    // 根据tab页查询数据
    changepage(index) {
      this.$refs['pages'].currentPage = index;
      this.getReturnsOrderList(index);
    },
    // 查看订单详情
    toOrderDetail(id) {
      this.$router.push({
        path: '/member/orderInfo',
        query: {
          orderSn: id
        }
      })
    },
    // 取消退换货
    cancleSq(id) {
      this.$Modal.confirm({
        content: '<p>确定要申请取消退换货吗？</p>',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          //todo 取消退换货
          cancelReturnApply({ returnOrderId: id }).then(resp => {
            if (resp.resCode === 1) {
              this.$Message.success(resp.resDesc);
              this.returnsOrderList.splice(this.returnsOrderList.findIndex(item => item.id === id), 1);
              setTimeout(() => {
                this.$router.go(0);
              }, 300);
            } else {
              this.$Message.error(resp.resDesc);
            }
          })
        },
        onCancel: () => {
        }
      });
    },
    // 获取退换货申请列表
    getReturnsOrderList: function (pageNo) {
      let _params = {
        'pageNo': pageNo,
        'pageSize': this.pageSize
      }
      getReturnsOrderList(_params).then((json) => {
        if (json.resCode == '1') {
          this.returnsOrderList = json.data.list;
          this.dataTotal = json.data.total;
        } else {
          this.$Message.error(json.resDesc);
        }
      });
    },
    formatDate(time) {
      return formatDate(time)
    }
  }
}
</script>
<style>
.mb-10 {
  margin-bottom: 10px;
}
.p-l50 {
  padding-left: 50px;
}
.rerurntype input {
  display: none;
}
.rerurntype span {
  color: #333;
  display: inline-block;
  margin-right: 10px;
  background: #ededed;
  border: #999 1px solid;
  border-radius: 28px;
  height: 28px;
  line-height: 28px;
  padding: 0 15px;
}
.rerurntype.active span {
  color: #fff;
  background: #ee0707;
  border: 0;
  box-shadow: inset 1px 1px 4px #790101;
}
.p-reason {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// returnList.vue?910c331e